export default __webpack_public_path__ + "static/meetup-banner-6030c6c41cdbef9f9650a4f29d7589d4.png";